const mahindraConfig = {
    clientId:
        '89f7c75cc7d56d4969a90431f3aa0bf6dff0f21e8656455ae0068483f578584a',
    id: 14,
    name: 'Mahindra',
    fullName: 'Mahindra Lifespaces',
    programName: 'M-Life',
    theme: 'mahindraTheme',
    darktheme: true,
    autoLogout: true,
    rewardFormLink: 'https://forms.gle/GFHaFgHB5538sCZi7',
    favicon:
        'data:image/png;base64,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',
    primaryColor: '#E31837',
    fontBody: `font-SourceSansPro`,
    fontTitle: `font-SourceSansPro`,
    googleConfig: {
        gID: 'G-VKS1PBE60T',
        keywordsContent:
            'Mahindra M-Life Elite real estate referral programs, Mahindra M-Life Elite real estate referral program, Mahindra M-Life Elite real estate refer and earn, Mahindra M-Life Elite real estate project refer, Mahindra M-Life Elite real estate, Mahindra M-Life Elite real estate loyalty program, Mahindra M-Life Elite real estate news, Mahindra M-Life Elite real estate upcoming projects in Bengaluru, Mahindra M-Life Elite real estate launch Mahindra M-Life Elite real estate, Mahindra M-Life Elite real estate launch, Mahindra M-Life Elite real estate program, Mahindra M-Life Elite real estate projects, Mahindra M-Life Elite real estate blogs, Mahindra M-Life Elite real estate offers, Mahindra M-Life Elite real estate upcoming projects in Bengaluru, Mahindra M-Life Elite real estate events, Mahindra M-Life Elite, Mahindra M-Life Elite, Mahindra M-Life Elite real estate best residential projects, Mahindra M-Life Elite real estate real estate developers, All New Projects by Mahindra M-Life Elite real estate Builders & Developers, Ongoing Projects by Mahindra M-Life Elite real estate Pvt Ltd, Mahindra M-Life Elite real estate Bengaluru, Mahindra M-Life Elite real estate new program, Mahindra M-Life Elite press release, Mahindra M-Life Elite upcoming projects, JP property group, Mahindra M-Life Elite bangalore, JP real estate, JP reit, jitu virwani, JP commercial projects, Mahindra M-Life Elite projects, Mahindra M-Life Elite projects in bangalore',
        descriptionContent:
            // "M-Life Elite, an exclusive membership program for Mahindra Lifespaces' homeowners, is crafted to elevate your experience through exclusive events and offers. Earn rewards as you build a community of your loved ones.",
            'M-Life Elite is an exclusive membership for Mahindra Lifespaces homeowners, designed to enhance your lifestyle with customer engagement activities and unique offers. Earn exciting rewards while building a vibrant community with your loved ones!​',
        authorContent: 'Mahindra M-Life Elite'
    },
    facebookPixelConfig: {
        id: '523926476033132', //PROD
        metaName: '',
        metaContent: ''
    },
    webengageLic: 'in~~47b66689',
    WAK: 'f07a0ff8-2bc8-4890-ae7a-0a24612002f4',
    uatFacebookPixelConfig: {
        id: '352151026892027',
        metaName: 'facebook-domain-verification',
        metaContent: '5jj1hhrr9u84kl2mbxppxk6u0x9b4v'
    },
    disableRMDetails: true,
    isCashoutDisabled: true,
    manuallySelectReward: true,
    IsEmployeeAndSalesAdmin: true,
    employeeRegistrationFormVisible: true,
    // allowSVReferral:true,
    logoLeft: {
        name: 'mahindraLogo',
        url: 'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Mahindra/mlife_elite-logo.png',
        stickyNavBarLogoClass:
            'lg:absolute bg-white w-[150px] px-5 top-0 left-0 block h-10 lg:h-[47px] ease-in duration-300',
        baseNavBarLogoClass:
            'lg:absolute bg-white w-[180px] lg:w-[200px] px-[25px] top-0 left-0 block h-10 lg:h-[66px] ease-out duration-300 '
    },
    navBarConfig: {
        dropDown: true,
        showLogin: true,
        height: ' h-10 lg:h-[66px] ease-out duration-300 ',
        stickyHeight: 'h-10 lg:h-[47px] ease-in duration-300 	',
        font: `font-SourceSansPro`,
        mobileIconColor: 'text-white',
        dropDownBg: 'bg-primary-content lg:bg-secondary-content ',
        baseNavBar: {
            border: false,
            borderClass: '',
            backgroundColor: 'bg-primary', // default: transparent
            containerClass: 'lg:mr-4 xl:mr-2  3xl:mr-40 ',
            itemClass:
                ' uppercase text-white lg:text-white text-[14px] lg:mr-3 lg:text-[12px]  font-normal tracking-[0.1em] lg:hover:border-b-[1px] lg:hover:border-primary',
            dropDownContainerClass: `lg:hover:text-white lg:focus:text-primary  lg:focus:shadow-outline `,
            dropDownItemClass:
                'tracking-[0.1em] text-white lg:text-[#D0D0D0] lg:hover:text-white  text-[14px] lg:text-[12px] '
        },
        stickyNavBar: {
            border: false,
            borderClass: '',
            backgroundColor: '', //default: primary-content,
            containerClass: ' lg:mr-4 xl:mr-2 3xl:mr-40 ', //entire Nav Bar Class (add min-w-full for godrej navbar effect)
            itemClass:
                ' text-white text-[14px] lg:text-[12px] lg:mr-3 font-normal hover:text-white tracking-[0.1em] uppercase ' // Each list element in NavBar (Text color, hover color, size)
        },
        showActiveLinkColor: false,
        footerNavItemClass: `tracking-widest uppercase text-white text-[12px] md:text-[14px] lg:text-white hover:text-white font-semibold lg:text-[12px] xl:text-[14px] 3xl:text-lg  font-SourceSansPro`
    },

    bannerNegativeTopMarginClass: '', //corresponding to  navBarHeightClass
    scrollToTargetAdjustedValue: 80,

    clientButtonClassName: `bg-primary text-white rounded py-3 px-10 hover:bg-transparent hover:border-2 hover:border-accent font-SourceSansPro`,

    increasePageSize: true, // if event layout 2 then true otherwise false
    showFooterRoutes: false,

    routes: {
        home: {
            name: 'HOME',
            path: '/',
            show: false,
            components: [
                // {
                //     type: 'HORIZONTAL_CAROUSEL',
                //     arrows: false,
                //     imgHeight: 'h-[100vh] lg:h-[95vh]',
                //     images: [
                //         {
                //             imgUrl: 'https://htmlemailer.s3.ap-south-1.amazonaws.com/html-media/Mahindra/m%3Blife+banner-01.jpg',
                //             imgPosition: 'object-center',
                //             mobileImgUrl:
                //                 'https://htmlemailer.s3.ap-south-1.amazonaws.com/html-media/Mahindra/sm_m%3Blife+banner-02.jpg',
                //             mobileImgPosition: 'object-center',
                //             onClick: 'CHANGE_PATH',
                //             path: 'gift-and-earn'
                //         }
                //     ]
                // },
                {
                    type: 'IMAGE',
                    url: 'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1738317817698_mahinra_HomeWeb',
                    className: 'w-full hidden lg:block'
                },
                {
                    type: 'IMAGE',
                    url: 'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1738317891510_homeMob',
                    className: 'w-full block lg:hidden'
                },
                // ABOUT US
                {
                    type: 'CUSTOM',
                    id: '',
                    url: '',
                    linearGradient: {
                        R: '255',
                        G: '255',
                        B: '255',
                        opacity: '0'
                    },
                    className:
                        'bg-white flex flex-col justify-center  text-center pt-12 ',
                    components: [
                        {
                            type: 'CUSTOM',
                            id: 'overview',
                            className:
                                'w-[85%] md:w-[60%] lg:w-[45%] xl:w-[42%] 2xl:w-[35%] flex items-center justify-center mx-auto ',
                            url: '',
                            linearGradient: {
                                R: '255',
                                G: '255',
                                B: '255',
                                opacity: '0'
                            },
                            components: [
                                {
                                    type: 'IMAGE',
                                    url: 'https://mldlprodstorage.blob.core.windows.net/live/2022/10/mahindra_logo_new_horizontal-scaled.webp',
                                    className: ' '
                                },
                                {
                                    type: 'TEXT',
                                    content: 'X',
                                    className: `font-SourceSansPro text-[17px] lg:text-2xl xl:text-3xl  mr-3 font-semibold text-secondary-focus `
                                },
                                {
                                    type: 'IMAGE',
                                    url: 'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Mahindra/logo-no-tagline.png',
                                    className: ''
                                }
                            ]
                        },
                        {
                            type: 'TEXT',
                            content:
                                'Referral and loyalty program for Mahindra Family',
                            className: `font-normal text-[17px] md:text-[20px] xl:text-[25px] text-secondary-focus self-center w-[95%] md:w-[84%] leading-6 break-words mb-5 ml-2 font-SourceSansPro`
                        },

                        {
                            type: 'TEXT',
                            content:
                                // `M-Life Elite, an exclusive membership program for Mahindra Lifespaces' homeowners, is crafted to elevate your experience through exclusive events and offers. Earn rewards as you build a community of your loved ones.`,
                                `M-Life Elite is an exclusive membership for Mahindra Lifespaces homeowners, designed to enhance your lifestyle with customer engagement activities and unique offers. Earn exciting rewards while building a vibrant community with your loved ones!​`,
                            className: `font-normal text-[17px] xl:text-[20px] text-secondary-focus  self-center w-[90%] md:w-[80%] xl:w-[75%] leading-[1.3] break-words md:mb-5  font-SourceSansPro`
                        },
                        {
                            type: 'ICONS_LAYOUT',
                            containerClassName:
                                'h-content lg:h-auto bg-white items-center pt-3 xl:pt-5 mb-5 ',
                            gridClassName:
                                'flex lg:grid lg:grid-cols-3 w-full w-[60%] md:w-[60%] lg:w-[80%] 2xl:w-[65%] m-auto overflow-x-scroll lg:overflow-x-hidden',
                            infotxtClassName: `font-normal text-[17px] xl:text-[20px] w-[95%] md:w-[50%] lg:w-[65%]  xl:w-[60%]  mx-auto text-secondary-focus  self-center  leading-[1.3] break-words mb-5  font-SourceSansPro`,
                            imgClassName:
                                'w-[40%] md:w-[22%] lg:w-[30%]  mx-auto',
                            info: [
                                {
                                    imgUrl:
                                        // 'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Mahindra/mahindra_icon_1.png',
                                        'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1737970993464_Referral1',
                                    infoText:
                                        'Incredible rewards​ worth lakhs at ₹99​'
                                },
                                {
                                    imgUrl:
                                        // 'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Mahindra/mahindra_icon_2.png',
                                        'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1737971140047_referral2',
                                    infoText: `Get offers and promotions`
                                },
                                {
                                    imgUrl:
                                        //  'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Mahindra/mahindra_icon_3.png',
                                        'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1737971166400_referral3',
                                    infoText: 'Customer engagement events​'
                                }
                            ]
                        },
                        {
                            type: 'BUTTON',
                            content: 'Refer Now',
                            className: `mx-auto text-white tracking-[0.1em] font-SourceSansPro text-[17px] xl:text-[18px] bg-[#E31837] w-[130px] xl:w-[150px] h-[40px] xl:h-[46px] rounded-[0.95rem] mb-10 font-SourceSansPro`,
                            path: 'gift-and-earn',
                            onClick: 'CHANGE_PATH_AND_SCROLL',
                            scrollTo: 'referral_section'
                        }
                    ]
                },

                {
                    type: 'CUSTOM',
                    id: '',
                    url: '',
                    linearGradient: {
                        R: '255',
                        G: '255',
                        B: '255',
                        opacity: '0',
                        size: 'cover'
                    },
                    className:
                        'bg-white flex flex-col justify-center items-center bg-top text-center py-10 ',
                    components: [
                        {
                            type: 'TEXT',
                            content: 'How it works?',
                            className: `text-secondary-focus text-center font-semibold px-2 text-2xl lg:text-[30px] xl:text-[35px] lg:mb-4  font-SourceSansPro`
                        },
                        {
                            type: 'CUSTOM',
                            // className:
                            //     'w-[95%] lg:w-[90%] 2xl:w-[80%] grid md:grid-cols-4 lg:grid-cols-3 gap-5 xl:gap-10 mx-auto pt-6  ',
                            className:
                                'w-[95%] lg:w-[90%] 2xl:w-[80%] grid md:grid-cols-2 lg:grid-cols-2 gap-5 xl:gap-10 mx-auto pt-6 ',
                            url: '',
                            linearGradient: {
                                R: '255',
                                G: '255',
                                B: '255',
                                opacity: '0'
                            },
                            components: [
                                {
                                    type: 'CUSTOM',
                                    className:
                                        'md:flex md:col-span-1 lg:col-span-1 gap-2',
                                    components: [
                                        {
                                            type: 'CUSTOM',
                                            className:
                                                'w-[20%] mx-auto flex items-center ',
                                            components: [
                                                {
                                                    type: 'IMAGE',
                                                    url:
                                                        //  'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Mahindra/mahindra_icon_4.png',
                                                        'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1738138440912_icon1',
                                                    className: ''
                                                }
                                            ]
                                        },

                                        {
                                            type: 'CUSTOM',
                                            className: 'px-2 mx-auto w-[80%]',
                                            components: [
                                                {
                                                    type: 'TEXT',
                                                    content: 'STEP 1',
                                                    className: `text-secondary-focus text-center font-semibold px-2 pb-2 text-xl xl:text-2xl  font-SourceSansPro`
                                                },
                                                {
                                                    type: 'TEXT',
                                                    content: `Click on the "Refer Now" tab below.​`,
                                                    className: `font-normal text-[16px] text-secondary-focus  self-center  leading-[1.3] break-words  font-SourceSansPro`
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    type: 'CUSTOM',
                                    className:
                                        'md:flex md:col-span-1 lg:col-span-1',
                                    components: [
                                        {
                                            type: 'CUSTOM',
                                            className:
                                                'w-[20%] mx-auto flex items-center ',
                                            components: [
                                                {
                                                    type: 'IMAGE',
                                                    url:
                                                        // 'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Mahindra/mahindra_icon_5.png',
                                                        'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1738138476192_icon_2',
                                                    className: ''
                                                }
                                            ]
                                        },

                                        {
                                            type: 'CUSTOM',
                                            className: 'px-2 mx-auto w-[80%]',
                                            components: [
                                                {
                                                    type: 'TEXT',
                                                    content: 'STEP 2',
                                                    className: `text-secondary-focus text-center font-semibold px-2 pb-2 text-xl xl:text-2xl  font-SourceSansPro`
                                                },
                                                {
                                                    type: 'TEXT',
                                                    content:
                                                        // `We connect with your references and introduce them to M-Life Elite.`,
                                                        `Select the city and project you'd like to refer your loved ones to.​`,
                                                    className: `font-normal text-[16px] text-secondary-focus  self-center  leading-[1.3] break-words  font-SourceSansPro`
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    type: 'CUSTOM',
                                    className:
                                        // 'md:flex md:col-start-2 md:col-span-2 lg:col-span-1  w-full',
                                        'md:flex md:col-span-1 lg:col-span-1',
                                    components: [
                                        {
                                            type: 'CUSTOM',
                                            className:
                                                'w-[20%]   mx-auto flex items-center ',
                                            components: [
                                                {
                                                    type: 'IMAGE',
                                                    url:
                                                        //  'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Mahindra/mahindra_icon_6.png',
                                                        'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1738138586420_icon_3',
                                                    className: 'pb-1'
                                                }
                                            ]
                                        },

                                        {
                                            type: 'CUSTOM',
                                            className: 'px-2 mx-auto w-[80%]',
                                            components: [
                                                {
                                                    type: 'TEXT',
                                                    content: 'STEP 3',
                                                    className: `text-secondary-focus text-center font-semibold px-2 pb-2 text-xl xl:text-2xl  font-SourceSansPro`
                                                },
                                                {
                                                    type: 'TEXT',
                                                    content:
                                                        //  `Once they book a home with Mahindra Lifespaces, you enjoy the reward.`,
                                                        `Enter or upload the contact details of your referral.​`,
                                                    className: `font-normal text-[16px] text-secondary-focus  self-center leading-[1.3] break-words  font-SourceSansPro`
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    type: 'CUSTOM',
                                    className:
                                        'md:flex md:col-span-1 lg:col-span-1',
                                    components: [
                                        {
                                            type: 'CUSTOM',
                                            className:
                                                'w-[20%] mx-auto flex items-center ',
                                            components: [
                                                {
                                                    type: 'IMAGE',
                                                    url: 'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1738138739256_icon_4',

                                                    className: ''
                                                }
                                            ]
                                        },

                                        {
                                            type: 'CUSTOM',
                                            className: 'px-2 mx-auto w-[80%]',
                                            components: [
                                                {
                                                    type: 'TEXT',
                                                    content: 'STEP 4',
                                                    className: `text-secondary-focus text-center font-semibold px-2 pb-2 text-xl xl:text-2xl  font-SourceSansPro`
                                                },
                                                {
                                                    type: 'TEXT',
                                                    content: `Submit and relax! Rewards unlock when your referral buys property.​`,
                                                    className: `font-normal text-[16px] text-secondary-focus  self-center  leading-[1.3] break-words  font-SourceSansPro`
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                //{
                //  type: 'CAROUSEL_NEW',
                //   buttonClass: `mx-auto text-white tracking-[0.1em] font-SourceSansPro text-[13px] bg-[#E31837] w-[170px] h-[46px] rounded-[0.25rem]`,
                //   fullWidth: true,
                //   showArrows: false,
                //   images: [
                // {
                //     imgUrl: 'https://mahindra-prod.s3.ap-south-1.amazonaws.com/Website/Uploads/Mahindra/Images/78891272.jpg',
                //     bgColor: '#3db151',
                //     logoUrl:
                //         'https://mldlprodstorage.blob.core.windows.net/live/2021/09/Mahindra-Alcove-logo.png',
                //     txtOne: 'Referrals and Earnings',
                //     txtTwo: 'Building a community needs trust. As part of M-Life, you can share your lifestyle with friends and family and earn benefits for successfully referring them. With us, you can build a community surrounded by people you love, creating a neighborhood that you feel connected to.',
                //     buttonText: 'REFER NOW',
                //     // MODIFY: REFER PAGE
                //     path: 'gift-and-earn',
                //     onClick: 'CHANGE_PATH',
                //     linkTwo:
                //         'https://www.mahindralifespaces.com/real-estate-properties'
                // }
                // {
                //     imgUrl: 'https://mahindra-prod.s3.ap-south-1.amazonaws.com/Website/Uploads/Mahindra/Images/7941133.jpg',
                //     bgColor: '#045D74',
                //     logoUrl:
                //         'https://mldlprodstorage.blob.core.windows.net/live/2021/09/Mahindra-Alcove-logo.png',
                //     txtOne: 'Offers and Promotions',
                //     txtTwo: 'At M-Life, we are all about creating value-added experiences that add more to your lifestyle. We give you access to premium and pan-india brands that elevate your lifestyle above the ordinary. Our goal is to curate the best experiences and bring them to you.',
                //     buttonText: 'AVAIL NOW',
                //     path: '/deals',
                //     linkTwo:
                //         'https://www.mahindralifespaces.com/real-estate-properties'
                // },
                // {
                //     imgUrl: 'https://cdn.loyalie.in/13662471.jpg',
                //     bgColor: '#49489D',
                //     logoUrl:
                //         'https://mldlprodstorage.blob.core.windows.net/live/2021/09/Mahindra-Alcove-logo.png',
                //     txtOne: 'Workshops and Events',
                //     txtTwo: 'Everyone needs a break from the monotony of life. Our workshops and events are designed to create engaging experiences with top collaborators, experts, and content creators.',
                //     buttonText: 'PARTICIPATE NOW',
                //     path: '/events',
                //     linkTwo:
                //         'https://www.mahindralifespaces.com/real-estate-properties'
                // },
                // {
                //     imgUrl: 'https://cdn.loyalie.in/43584331.jpg',
                //     bgColor: '#be8c46',
                //     logoUrl:
                //         'https://mldlprodstorage.blob.core.windows.net/live/2021/09/Mahindra-Alcove-logo.png',
                //     txtOne: 'Interactive Blogs',
                //     txtTwo: 'Reading adds more to what we know and how we perceive the world. As part of the M-Life experience, we bring you bite-sized infotainment to keep adding to the things you know.',
                //     buttonText: 'READ NOW',
                //     path: '/blogs',
                //     linkTwo:
                //         'https://www.mahindralifespaces.com/real-estate-properties'
                // }
                //   ]
                // },
                {
                    type: 'CUSTOM',
                    id: 'about',
                    // url: 'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Mahindra/about_mahindra_bg.jpg',
                    urls: [
                        'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1738066637035_Mahindra1',
                        'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1738079330363_mahindra2',
                        'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1738585584367_lifespace_3',
                        'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1738079579815_mahindra4',
                        'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1738066242457_Mahindra5',
                        'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1738066574440_Mahindra6'
                    ],
                    linearGradient: {
                        R: '255',
                        G: '255',
                        B: '255',
                        opacity: '0',
                        size: 'cover'
                    },
                    className:
                        'bg-white flex flex-col justify-end bg-center bg-cover text-center pt-12 h-[95vh]',
                    components: [
                        {
                            type: 'CUSTOM',
                            className:
                                ' flex flex-col items-end justify-center mx-auto py-4',
                            url: '',
                            linearGradient: {
                                R: '27',
                                G: '73',
                                B: '39',
                                opacity: '0.82'
                            },
                            components: [
                                {
                                    type: 'TEXT',
                                    content: 'ABOUT MAHINDRA LIFESPACES',
                                    className: `font-normal text-[18px] lg:text-[22px] xl:text-[25px] text-white self-center w-[84%] leading-6 break-words mb-2 ml-2 font-SourceSansPro`
                                },

                                {
                                    type: 'TEXT',
                                    content: `Established in 1994, Mahindra Lifespace Developers Ltd. brings the Mahindra Group’s philosophy of ‘Rise’ to India’s real estate and infrastructure industry through thriving residential communities and enabling business ecosystems. Our development footprint spans 38.49 million sq. ft. of completed, ongoing and forthcoming residential projects across seven cities. ​With a 100% Green portfolio since 2014, we are working towards carbon neutrality by 2040 and actively support research on green buildings tailored to climatic conditions in India. Mahindra Lifespaces® is the recipient of over 90 awards for its projects and ESG initiatives.​`,
                                    className: `font-extralight lg:font-thin text-[16px] 2xl:text-[20px] text-white self-center w-[95%] lg:w-[95%] xl:w-[95%] 2xl:w-[95%] leading-[1.3] break-words mb-2  font-SourceSansPro`,
                                    showReadMore: true // Flag to enable Read More/Read Less
                                },
                                {
                                    type: 'BUTTON',
                                    content: 'Refer Now',
                                    className: `mx-auto text-white tracking-[0.1em] font-SourceSansPro text-[17px] xl:text-[18px] bg-[#E31837] w-[130px] xl:w-[150px] h-[40px] xl:h-[46px] rounded-[0.95rem] font-SourceSansPro`,
                                    path: 'gift-and-earn',
                                    onClick: 'CHANGE_PATH_AND_SCROLL',
                                    scrollTo: 'referral_section'
                                }
                            ]
                        }
                    ]
                },
                // // OUR PROJECTS
                {
                    type: 'CUSTOM',
                    //  url: 'https://cdn.loyalie.in/4685974.png',
                    linearGradient: {
                        R: '248',
                        G: '248',
                        B: '248',
                        opacity: '0'
                    },
                    className:
                        'bg-white xl:text-center text-center xl:w-full w-[100%] text-[#f58020] pt-12 ',
                    id: 'mahindra_projects_locations',
                    components: [
                        {
                            type: 'TEXT',
                            content: 'Our Projects',
                            className: `text-secondary-focus text-center font-semibold px-2 text-2xl lg:text-[30px] xl:text-[35px] font-SourceSansPro`
                        },
                        {
                            type: 'CAROUSEL',
                            caraouselClassName:
                                'px-8 md:px-24 lg:px-12 xl:px-16 md:py-10 lg:pt-6 lg:pb-10 mx-auto relative',
                            imageContainerClassName: 'w-auto p-4',
                            imageClassName:
                                ' w-[250px] h-[160px] object-cover drop-shadow-xl mx-auto',
                            arrows: true,
                            autoplay: true,
                            autoplaySpeed: 1500,
                            xlSlidesToShow: 4,
                            infinite: true,
                            dots: false,
                            slidesToShow: 5,
                            pauseOnHover: true,
                            speed: 1500,
                            // internalRedirect: true,
                            onImageClick: 'NO_ACTION',
                            getProjects: true
                        }
                    ]
                }
            ]
        }
    },
    webview: { smallCategories: true },
    referPage: {
        banner: {
            loginBannerComponents: [
                {
                    type: 'BANNER',
                    linearGradient: {
                        R: '0',
                        G: '0',
                        B: '0',
                        opacity: '0'
                    },
                    backgroundImage:
                        'https://mahindrauat.s3.ap-south-1.amazonaws.com/Website/Uploads/Mahindra/Images/80169976.jpg',
                    backgroundImageMobile:
                        'https://mahindrauat.s3.ap-south-1.amazonaws.com/Website/Uploads/Mahindra/Images/80169976.jpg',
                    bannerContainerClassName:
                        'relative hero hero-content max-w-full h-[70vh] object-cover bg-left lg:bg-left ',
                    components: [
                        {
                            type: 'TEXT',
                            content:
                                'Refer your loved ones and get rewards on every successful referral ',
                            className: `text-center lg:text-left text-white md:text-primary text-[18px] md:text-[20px] xl:text-[25px] font-bold my-5 tracking-wide md:w-[45%]  xl:w-[50%] ml-auto leading-5 xl:leading-7 font-SourceSansPro`
                        },
                        {
                            type: 'CUSTOM',
                            className:
                                ' md:w-[45%] xl:w-[50%] ml-auto text-center lg:text-left',
                            components: [
                                {
                                    type: 'BUTTON',
                                    content: 'Start Referring Now',
                                    onClick: 'OPEN_LOGIN',
                                    className: `mx-auto text-white tracking-[0.1em] font-SourceSansPro text-[17px] xl:text-[18px] bg-[#E31837] px-2 h-[40px] xl:h-[46px] rounded-[0.95rem] font-SourceSansPro`
                                }
                            ]
                        }
                    ]
                }
            ]
        },

        components: [],

        customize: {
            heading: `font-SourceSansPro`,
            body: `font-SourceSansPro`
        }
    },

    blogs: {
        banner: {
            bannerContainerClassName:
                'hero hero-content max-w-full h-[300px] lg:h-[450px] bg-top lg:bg-top  mx-auto text-center ',

            linearGradient: {
                string: '100,65,43,0.7',
                R: '20',
                G: '20',
                B: '20',
                opacity: '0.25'
            },
            backgroundImage:
                'https://mahindra-prod.s3.ap-south-1.amazonaws.com/Website/Uploads/Mahindra/Images/45085885.jpg',
            backgroundImageMobile:
                'https://mahindra-prod.s3.ap-south-1.amazonaws.com/Website/Uploads/Mahindra/Images/74522107.jpg',
            components: [
                {
                    type: 'TEXT',
                    content: 'Mahindra Readers’ Club',
                    className: `font-semibold mt-12 md:mt-10 mb-5 text-2xl md:text-4xl lg:text-[40px] tracking-wide font-SourceSansPro`
                },
                {
                    type: 'DIVIDER',
                    className:
                        'mt-1 self-center mx-auto w-[20%] lg:w-[20%] bg-primary border-none h-[6px]',
                    classNameContainer: ''
                },
                {
                    type: 'TEXT',
                    content:
                        'Bringing together information and entertainment for you.',
                    className: `font-normal mt-5 mb-3  text-xl md:text-base lg:text-[17px] tracking-wide font-SourceSansPro`
                },
                {
                    type: 'BUTTON',
                    content: 'Read More',
                    scrollTo: 'blogs_section',
                    onClick: 'SCROLL',
                    className: `mx-auto text-center text-white  tracking-wide text-[13px]  bg-primary w-[170px] h-[46px] rounded-[0.25rem] font-SourceSansPro`
                }
            ],
            loginBannerComponents: [
                {
                    type: 'TEXT',
                    content: 'Mahindra Readers’ Club',
                    className: `font-semibold mt-12 md:mt-10 mb-5 text-2xl md:text-4xl lg:text-[40px] tracking-wide font-SourceSansPro`
                },
                {
                    type: 'DIVIDER',
                    className:
                        'mt-1 self-center mx-auto w-[20%] lg:w-[20%] bg-primary border-none h-[6px]',
                    classNameContainer: ''
                },
                {
                    type: 'TEXT',
                    content:
                        'Bringing together information and entertainment for you.',
                    className: `font-normal mt-5 mb-3  text-xl md:text-base lg:text-[17px] tracking-wide font-SourceSansPro`
                },
                {
                    type: 'BUTTON',
                    content: 'Login To Read Now',
                    onClick: 'OPEN_LOGIN',
                    className: `mx-auto text-center text-white  tracking-wide text-[13px] bg-primary w-[170px] h-[46px] rounded-[0.25rem] font-SourceSansPro`
                }
            ]
        },

        linearGradient: {
            R: '236',
            G: '247',
            B: '228',
            opacity: '1',
            size: '30% auto'
        },
        detailsPageBackgroundColor: 'bg-neutral',
        comments: {
            commentButtonClass: `text-white  tracking-wide text-[13px] bg-primary font-SourceSansPro`,
            initialsClass: ' '
        },
        primaryColor: '#E31837',
        fontHeading: `font-SourceSansPro`,
        fontBody: `font-SourceSansPro`,
        button: {
            position: 'self-end',
            bgColor: true,
            border: false
        },
        sliderBanner: {
            featuredPost: {
                featuredPostClass: ``,
                headingClass: `text-[35px]  font-semibold text-primary mt-3 leading-9 break-words`,
                summaryClass: ` `
            },
            sectionHeadings: `text-[30px] md:text-[40px]`
        },
        layout5: {
            headingClass: `text-[22px] 3xl:text-[20px]`,
            categoryClass: ``,
            summaryClass: ``,
            buttonClass: ``,
            dateClass: ``
        }
    },
    events: {
        banner: {
            linearGradient: {
                R: '0',
                G: '0',
                B: '0',
                opacity: '0.1'
            },

            negativeMargin: '',
            containerClass: ' text-white w-full lg:w-[50%]',
            heading: '',
            headingClass: `font-semibold text-center  lg:w-[70%] text-[30px] lg:text-[40px] text-primary   font-SourceSansPro`,
            subHeading: '',
            subHeadingClass: `text-accent  font-semibold text-[33px] font-SourceSansPro`
        },

        loginBanner: {
            bannerContainerClassName:
                'mt-16 2xl:mt-24 hero hero-content max-w-full h-[70vh] lg:h-[105vh] bg-top lg:bg-top  mx-auto text-center',

            components: [
                {
                    type: 'TEXT',
                    content: 'CURATED WORKSHOPS AND EVENTS',
                    className: `font-semibold mt-12 md:mt-10 mb-5 text-2xl md:text-4xl lg:text-[40px] tracking-wider font-SourceSansPro`
                },
                {
                    type: 'DIVIDER',
                    className:
                        'mt-1 self-center mx-auto w-[20%] lg:w-[20%] bg-primary border-none h-[6px]',
                    classNameContainer: ''
                },
                {
                    type: 'TEXT',
                    content:
                        'Meet and connect with like-minded people of your bespoke community',
                    className: `font-normal mt-5 mb-3  text-xl md:text-base lg:text-[17px] tracking-wider font-SourceSansPro`
                },
                {
                    type: 'BUTTON',
                    content: 'Login To Participate Now',
                    onClick: 'OPEN_LOGIN',
                    className: `mx-auto text-center text-white  tracking-wide text-[13px] bg-primary px-4 h-[46px] rounded-[0.25rem] font-SourceSansPro`
                }
            ]
        },
        fontHeading: `font-SourceSansPro`,
        fontBody: `font-SourceSansPro`,
        eventsSection: {
            overlayClass: 'bg-neutral',
            linearGradient: {
                R: '236',
                G: '247',
                B: '228',
                opacity: '0',
                size: '30% auto'
            },

            headingClass: `z-10 font-bold text-[30px] md:text-[35px] !text-[#2F3031] mt-16  `,
            components: [
                {
                    type: 'DIVIDER',
                    className:
                        'z-10 mt-3 self-center mx-auto w-[30%] md:w-[20%] lg:w-[15%] xl:w-[15%] 2xl:w-[8%] bg-primary border-none h-[5px]',
                    classNameContainer: ''
                }
            ],
            filterHeadingClass: `z-10 mt-10 text-secondary-focus `
        },
        eventLayout: {
            titleClass: `text-accent`
        }
    },

    deals: {
        rewardsBanner: {
            backgroundImage:
                'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1738135192791_RewardsWEb',
            backgroundImageMobile:
                'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1738135226420_RewardsMob'
        },
        darkTheme: {
            selected: 'hover:bg-primary focus:bg-primary',
            text: 'text-black',
            border: ''
        },

        dealsSection: {
            additionalTextClass: `z-10 text-2xl xl:text-3xl  text-secondary font-semibold font-SourceSansPro `,
            subAdditionalTextClass: `z-10 font-normal text-secondary-focus font-SourceSansPro`,
            noDealsClass: `text-primary text-2xl text-center my-6
         font-SourceSansPro`
        },
        dealLayout: {
            listTitleClass: `text-[18px] leading-6 lg:leading-5 2xl:leading-6 text-primary font-SourceSansPro`,
            listBodyClass: `font-SourceSansPro`,
            titleClassName: `text-primary font-semibold  text-2xl xl:text-xl 2xl:text-2xl leading-7  mt-4 font-SourceSansPro `,
            termsAndConditionsClassName: `font-semibold capitalize text-secondary-focus text-[14px]  font-SourceSansPro`,
            redeemNowButtonConfig: {
                type: 'BUTTON',
                content: 'Redeem Now',
                className: `bg-primary self-center text-white rounded  text-[13px] w-full lg:w-[175px] h-[46px] rounded-[0.25rem] font-SourceSansPro`
            }
        }
    },
    projects: {
        components: [
            {
                type: 'BANNER',
                linearGradient: {
                    string: '100,65,43,0.7',
                    R: '20',
                    G: '20',
                    B: '20',
                    opacity: '0.3'
                },
                backgroundImage:
                    'https://is1-2.housingcdn.com/4f2250e8/49325cf41279115053c9b0adbe1080ad/v0/fs/mahindra_happinest_kalyan_project_a-kalyan_west-mumbai-mahindra_lifespaces.jpeg',

                backgroundImageMobile:
                    'https://is1-2.housingcdn.com/4f2250e8/49325cf41279115053c9b0adbe1080ad/v0/fs/mahindra_happinest_kalyan_project_a-kalyan_west-mumbai-mahindra_lifespaces.jpeg',
                bannerContainerClassName:
                    'hero hero-content max-w-full h-[300px] lg:h-[400px]  bg-bottom',

                components: [
                    {
                        type: 'TEXT',
                        content: 'Mahindra Projects',

                        className: `font-semibold  mb-3 text-2xl text-center md:text-4xl lg:text-[40px] tracking-wider font-SourceSansPro`
                    },
                    {
                        type: 'DIVIDER',
                        className:
                            'mt-1 self-center mx-auto w-[40%] md:w-[35%] lg:w-[25%] xl:w-[20%] bg-primary border-none h-[6px]',
                        classNameContainer: ''
                    }
                ]
            }
        ],
        moduleConfig: {
            hideProjects: true,
            overlayClass: 'bg-neutral opacity-[.97]',
            propertyBackgroundColorWithOverlay: 'bg-neutral'
        }
    },
    // header: {
    //     headerClass: 'hidden lg:block h-36 bg-primary'
    // },
    contactUs: {
        overlayClass: '',
        contactUsContent: `We’re committed to enhancing your experience with us. If you have questions or concerns, please contact us and share your inquiry below so we can assist you better.​​`
    },
    termsAndConditions: {
        fontHeading: `font-SourceSansPro`,
        fontBody: `font-SourceSansPro`,
        terms: [
            '“Referrer” shall mean either of (i) an existing eligible customer having booked a unit in a Mahindra project, and has executed a registered Agreement to Sale; or (ii) employee of Mahindra Lifespaces; or (iii) any other individual as specified by Mahindra Lifespaces; and wishes to introduce/refer another person(s) to book a unit in any of the eligible registered real estate project/s proposed to be developed (“Mahindra Project/s”) by Mahindra Lifespace Developers Limited (“MLDL”).',
            '‘Referee’ shall mean an eligible person introduced/Referee to by the Referrer and has booked one or more units in any of the eligible registered real estate Mahindra Project/s by a registered agreement for sale for such unit(s).',
            'Referrer participation in the Referral Reward Program shall be subject to his/her/them holding a registered Agreement to Sale executed in his/her/their favor by Mahindra Lifespaces. The Referrer participants should complete his/her/their E-KYC at the time of claiming the rewards.',
            'Referrer shall not be able to refer existing customer(s) of Mahindra Lifespaces. Referrer shall not be able to refer customer(s) who has/have in in the last 30 days : (i) either visited the MLDL site or connected virtually by any other sales verticals of MLDL as a Direct Walk-in or through Channel Partner. Assigning Referral Reward and determining eligibility as to who qualifies as ‘Referrer’ and ‘Referee’ will be at sole discretion of Reloy and Mahindra Lifespaces and the same shall not be challenged/contested by the Referrer and/or the Referee at any point of time.',
            'In the event, that a referral is submitted twice from different Referrers, then the first referral received will be eligible for the Reward (subject to other applicable terms herein) and shall not be disputed by the other Referrers, in such cases the final decision will be at the sole discretion of Reloy and Mahindra Lifespaces.',
            'Referrals are not valid where the Referrer and the Referee party are one and the same person.',
            'Referrals will be valid for 30 days from the date a Referee person/party has visited the site, ’ unless such person/party has paid any booking amount to Mahindra Lifespaces within the said period of 30 days .',
            'By accepting our terms and conditions, the Referrer represents and confirm that they have the authority to disclose the name and details of the Referee to Mahindra Lifespaces.',
            'Referral RewardSubject to terms mentioned herein, the eligible Referee under this referral programme is entitled either for a product or services offered on this platform in form of a Referral Reward. If the Referee opts to exercise the option to purchase product, then such products shall be purchased on MLife Elite E- store Referral Reward.The Referee acknowledges that the purchase of the Referral Rewards shall be a transaction between the Referee and such third party vendor/ service provider, and shall subject to the terms and conditions of the website / application of such identified vendors/ service providers.',
            'This Referral Reward Program cannot be clubbed with any other offer /scheme, whether run by Mahindra Lifespaces or otherwise. The Referral Rewards cannot be converted to cash. The Referee is solely liable for the taxes and all direct/ indirect costs as applicable on the reward.',
            'The terms and conditions of this program are subject to change at any time. Mahindra Lifespaces/ Reloy will intimate the same to the Referrer. This program may at any given point be terminated at the discretion of Mahindra.',
            'All disputes shall be subject to exclusive jurisdiction of Mumbai courts.'
        ],
        components: [
            {
                type: 'CUSTOM',
                linearGradient: {
                    R: '236',
                    G: '247',
                    B: '228',
                    opacity: '0'
                },
                className: 'text-left ',

                components: [
                    {
                        type: 'TEXT',
                        content:
                            'Terms and Conditions for Rewards Redemption Program',
                        className: `tracking-wide mt-4 font-semibold underline text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'TEXT',
                        content: 'General Terms',

                        className: `tracking-wide mt-4 font-semibold underline text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'TEXT',
                        content: 'Eligibility:',

                        className: `tracking-wide  mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'The users including Indian and Non- Resident Indians (“NRIs”) are eligible under the rewards program and can purchase Referral Products. The eligibility is based on the criteria set by the platform, and the rewards are non-transferable.',
                            'The option to claim the Referral reward Referral Rewardwould only be valid for a limited period of time, as communicated by Reloy /Mahindra Lifespaces.',
                            'The Referral Reward caters to product and services to be delivered and availed within India.'
                        ],
                        listClassName: ` font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'TEXT',
                        content: 'Non-Monetary Rewards:',

                        className: `tracking-wide mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'The Referral Rewards offered through the program do not have any cash equivalent or monetary value. They cannot be exchanged for cash, credit, or any other form of compensation.'
                        ],
                        listClassName: `font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'TEXT',
                        content: 'Limited Availability:',

                        className: `tracking-wide mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'Referral Rewards are subject to availability. The platform reserves the right to substitute products with similar items of equal or greater value if necessary.'
                        ],
                        listClassName: ` font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'TEXT',
                        content: 'Redemption Process',

                        className: `tracking-wide font-semibold underline mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'TEXT',
                        content: 'Single Redemption:',

                        className: `tracking-wide mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'Users can redeem only one Referral Product unless otherwise stated. Once the Referral Product is selected, it cannot be replaced with another product.'
                        ],
                        listClassName: ` font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'TEXT',
                        content: 'Confirmation:',

                        className: `tracking-wide mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'Upon successful purchase of a Referral Reward, users will receive a confirmation email or message from the third party vendor/service provider, including the details of their selected Referral Product(s) and an estimated delivery timeline.'
                        ],
                        listClassName: ` font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'TEXT',
                        content: 'Delivery',

                        className: `tracking-wide font-semibold underline mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'TEXT',
                        content: 'Shipping:',

                        className: `tracking-wide mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'Products will be shipped to the address provided by the user at the time of redemption. Users are responsible for ensuring the accuracy of the delivery information.',
                            'In case the Referrer is an NRI, he/she must mandatorily provide a shipping address within India.'
                        ],
                        listClassName: `font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'TEXT',
                        content: 'Delivery Timeline:',

                        className: `tracking-wide mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'Estimated delivery times are provided at the time of redemption. However, delays may occur due to external factors (e.g., shipping issues, supply shortages). The platform is not liable for any delays beyond its control.'
                        ],
                        listClassName: `font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'TEXT',
                        content: 'Delivery Area:',

                        className: `tracking-wide mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'Referral Rewards can only be delivered to locations within the specified delivery area. If the delivery address is outside the supported area, the delivery may be cancelled, or alternative arrangements may be made at the platform’s discretion. Delivery is supported only in India.'
                        ],
                        listClassName: ` font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'TEXT',
                        content: 'Cancellations, Refunds, and Replacements',

                        className: `tracking-wide font-semibold underline mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'TEXT',
                        content: 'Cancellations by User:',

                        className: `tracking-wide mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'Once a Referral Reward is redeemed and confirmed, users cannot cancel or modify their selection. Please ensure that you have reviewed your selection carefully before confirming.'
                        ],
                        listClassName: `font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'TEXT',
                        content: 'Cancellations by the Platform:',

                        className: `tracking-wide mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'The platform reserves the right to cancel any redemption in case of fraud, abuse, or other violations of the terms. In such cases, no alternative reward or compensation will be provided.'
                        ],
                        listClassName: `font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'TEXT',
                        content: 'Refunds:',

                        className: `tracking-wide mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'Since Referral reward are provided as part of a loyalty program with no monetary value, no refunds or credits will be issued for redeemed products.'
                        ],
                        listClassName: `font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'TEXT',
                        content: 'Product Damage or Defects:',

                        className: `tracking-wide mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'Reloy and Mahindra Lifespaces do not guarantee the experience, quality, durability or reliability of the Referral Rewardreward.',
                            'If the Referral Reward arrives damaged or defective, users must notify the platform within 7 days of receiving the product. The platform will arrange for a replacement or provide instructions on how to return the defective product.'
                        ],
                        listClassName: `font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'TEXT',
                        content: 'Replacement Policy:',

                        className: `tracking-wide mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'In cases of damaged or defective Referral Reward, replacements will be provided based on availability. If the Referral Reward is no longer available, a similar Referral Reward of equal value may be offered. The platform does not guarantee the exact same Referral Reward will be available for replacement.'
                        ],
                        listClassName: ` font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: ['Warranty and Liability'],
                        listClassName: `text-secondary-focus font-normal text-[17px] leading-7 font-SourceSansPro`,
                        // listclassName: `tracking-wide text-secondary-focus mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                        classNameContainer: 'px-6 mt-4'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: ['Product Warranty:'],
                        listClassName: ` font-normal text-[17px] leading-7 font-SourceSansPro`,
                        // listclassName: `tracking-wide text-secondary-focus mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                        classNameContainer: 'px-6 mt-4'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'Some Referral Reward may come with a manufacturer’s warranty. The platform does not provide warranties for the rewards beyond what is offered by the product manufacturer. Users should refer to and rely upon the manufacturer for any warranty claims or support.'
                        ],
                        listClassName: `font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: ['No Liability:'],
                        listClassName: `font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-4'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'The platform is not liable for any personal injury, property damage, or other losses resulting from the use of the Referral Reward. Users assume all risks associated with the use of Referral Reward.'
                        ],
                        listClassName: `font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'TEXT',
                        content: 'Third-Party Services:',

                        className: `tracking-wide mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'If any third-party services (e.g., delivery, installation) are involved, the platform is not responsible for any issues or damages resulting from those services.'
                        ],
                        listClassName: `font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'TEXT',
                        content: 'Program Changes and Termination',

                        className: `tracking-wide font-semibold underline mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'TEXT',
                        content: 'Program Modifications:',

                        className: `tracking-wide text-secondary-focus mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'The platform reserves the right to modify or discontinue the rewards program at any time without notice. This includes changes to the availability of rewards, eligibility criteria, and other program features.'
                        ],
                        listClassName: `text-secondary-focus font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'TEXT',
                        content: 'Termination:',

                        className: `tracking-wide text-secondary-focus mt-4 font-medium text-[20px] md:text-[20px] font-SourceSansPro`
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'In the event of program termination, users will be given reasonable notice. After the termination date, any option to purchase Referral Reward will expire and be forfeited, and will be invalid.'
                        ],
                        listClassName: `text-secondary-focus font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: ['User Responsibilities'],
                        listClassName: `text-secondary-focus font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-4'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: ['Accurate Information:'],
                        listClassName: `text-secondary-focus font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-4'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'Users are responsible for providing accurate and up-to-date information during the redemption process, including shipping address and contact details.'
                        ],
                        listClassName: `text-secondary-focus font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: ['Account Security:'],
                        listClassName: `text-secondary-focus font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-4'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'Users must ensure the security of their account and must not share their account details with third parties. The platform is not responsible for unauthorized redemptions made through compromised accounts.'
                        ],
                        listClassName: `text-secondary-focus font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: ['Dispute Resolution'],
                        listClassName: `text-secondary-focus font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-4'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: ['Governing Law:'],
                        listClassName: `text-secondary-focus font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-4'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'These terms and conditions are governed by the laws of India. Any disputes arising from the program shall be resolved through the courts of Mumbai.'
                        ],
                        listClassName: `text-secondary-focus font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: ['Dispute Resolution Process:'],
                        listClassName: `text-secondary-focus font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-4'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'If you have a dispute regarding the rewards program or any redeemed products, please contact our support team at rewards@reloy.co or +91-99867-34916. We will endeavour make every effort to resolve the issue amicably.'
                        ],
                        listClassName: `text-secondary-focus font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: ['Force Majeure'],
                        listClassName: `text-secondary-focus font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-4'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'The option to purchase the Referral Rewards herein are subject to force majeure circumstances including without limitation, floods, natural disasters, war, act of terror, political unrests, technical snags, act of God or any circumstance beyond the reasonable control of Reloy, Mahindra Lifespaces or the third-party vendor/ service provider.'
                        ],
                        listClassName: `text-secondary-focus font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: ['Contact Information'],
                        listClassName: `text-secondary-focus font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-4'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: ['Customer Support:'],
                        listClassName: `text-secondary-focus font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-4'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'For any questions or concerns regarding the rewards program, please reach out to our customer support team at rewards@reloy.co or +91-99867-34916.'
                        ],
                        listClassName: `text-secondary-focus font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: ['Final Note'],
                        listClassName: `text-secondary-focus font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-4'
                    },
                    {
                        type: 'LIST',
                        listStyle: 'list-disc',
                        points: [
                            'Please review these terms carefully before redeeming your rewards. By participating in the rewards program, you agree to comply with these terms and conditions.'
                        ],
                        listClassName: `text-secondary-focus font-normal text-[17px] leading-7 font-SourceSansPro`,
                        classNameContainer: 'px-6 mt-6'
                    }
                ]
            }
        ]
    },

    footer: {
        backgroundColor: '',
        containerClassName: '!bg-white pt-5 pb-2 lg:px-7 xl:mx-0',
        logo: 'https://cdn.loyalie.in/27822817.png',
        footerLogoClassName: ' w-full md:!w-[20%] lg:!w-[18%]  ',
        termsAndConditionsContent: 'Terms and Conditions',
        termsAndConditionsClassName: `bg-neutral inline-flex float-right mb-2 px-2 py-1 !text-[13px] mt-1 md:!text-[12px] 2xl:!text-[12px] 3xl:!text-[12px]  mr-6 cursor-pointer !text-black font-SourceSansPro`,
        content:
            'Reloy is run by Loyalie IT-Solutions Pvt. Ltd. This referral program is run by Loyalie IT Solutions Pvt. Ltd. and the referral payout will be processed by them. Loyalie IT Solutions Pvt. Ltd. is registered as a Real Estate Agent under RERA in Maharashtra MAHARERA NO - A51900010267 | Haryana RERA No. - HRERA-PKL-REA-239-2020 | Tamil Nadu RERA NO - TN/Agent/0092/2023 | Karnataka RERA NO-PRM/KA/RERA/1251/309/AG/180524/000935 | West Bengal RERA NO – HIRA/A/KOL/2019/000350 | Uttar Pradesh RERA NO – UPRERAAGT22593 | Gujarat RERA No: AG/GJ/AHMEDABAD/AHMEDABAD CITY/AUDA/AA01891/090327R1 | Delhi RERA Application Reference No: 22-3754-2891 | Goa RERA NO – AGGO02210817 | Telangana RERA NO – A02500001321 | maharera.mahaonline.gov.in | haryanarera.gov.in | www.tnrera.in | rera.karnataka.gov.in | http://hira.wb.gov.in | https://www.up-rera.in | https://gujrera.gujarat.gov.in | https://rera.delhi.gov.in | https://rera.goa.gov.in | http://rera.telangana.gov.in All brands have their respective terms and conditions and neither Century Real Estate nor Reloy will be responsible in case of any concerns. Images for representational purposes only.',
        contentClassName: ` !text-[12px] pl-10 md:pl-4 lg:pl-7 2xl:pl-4 pr-10 md:pr-6 lg:pr-0 xl:pr-3 self-center md:!w-[85%] lg:!text-[11px] 3xl:!text-[12px] leading-4 text-secondary-focus`
    },
    referralForm: {
        disableInfluencerLink: true,
        backgroundImage:
            'https://mahindrauat.s3.ap-south-1.amazonaws.com/Website/Uploads/Mahindra/Images/80169976.jpg',
        height: 'h-[70vh]',
        removeBlur: true,
        linearGradient: {
            degree: '90deg',
            R1: '0',
            G1: '0',
            B1: '0',
            opacity1: '0.6',
            R2: '0',
            G2: '0',
            B2: '0',
            opacity2: '0.6'
        },
        allowSVReferral: true,
        userTypes: {
            siteVisitor: true,
            bookedCustomer: true,
            employee: true,
            employeeHeading1: '',
            salesAdmin: true,
            influencer: false
        },
        leadEmailMandatory: false
    }
};
export default mahindraConfig;
